import BankDetails from "../../../../../components/_utils/AccountCreationComponents/BankDetails";
import CommonBankLogo from "../../../../../components/_utils/CommonBankLogo";
import CommonLayout from "../../../../../components/_utils/CommonLayout";
import { formatAccountNumber } from "../../../../../components/_utils/FormatAccountNumber";
import { linkIdentifier } from "../../../../../utils/linkIdentifier";

const FieldForceAccountEditConfirm = (props) => {
  return (
    <div className="w-width-full max-w-max-content-width snap-start flex flex-col lg:flex-row justify-between items-start mb-margin-md gap-gap-md lg:gap-gap-xl">
      <CommonLayout>
        <BankDetails
          payload={props?.payload}
          previewMode={true}
          headerText={"Updated Bank Details"}
          manualVirtualAccount={props?.manualVirtualAccount}
        />

        <div className="bankleft_edit">
          <div className="w-full h-auto  p-padding-md rounded-border-radius-md bg-primary-card custom-boxShadow">
            <div className=" text-text-secondary">
              <p className="text-text-primary font-semibold text-font-md">
                Archive Account Details
              </p>
              <p className="text-text-secondary font-normal mt-margin-xs text-font-xs">
                This account will be archived.
              </p>
              <div className=" border-b border-primary-bg w-full my-margin-sm"></div>
              <div className="pb-padding-sm">
                <h5 className="text-text-primary font-semibold mb-margin-sm text-font-md">
                  {props?.payload?.pan_no && props?.payload?.gstin_detail
                    ? "Beneficiary PAN & GSTIN Details"
                    : " PAN Details"}
                </h5>
                <span className="text-text-primary font-normal mt-margin-sm text-font-md">
                  {props?.payload?.pan_no}
                </span>
                <p className="text-text-secondary font-normal mt-margin-xs text-font-xs">
                  PAN details
                </p>

                {props?.payload?.gstin_detail ? (
                  <div className=" mt-margin-sm">
                    <span className="text-text-primary font-normal text-font-md">
                      {props?.payload?.gstin_detail}
                    </span>
                    <p className="text-text-secondary font-normal text-font-xs">
                      GST details
                    </p>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className=" border-b border-primary-bg w-full"></div>
              <div className=" pt-padding-sm">
                <h5 className="text-text-primary font-semibold mb-margin-sm text-font-md capitalize">
                  Bank details
                </h5>

                <div className="flex justify-between">
                  <div className="flex flex-col gap-gap-xs">
                    <span className="text-text-primary font-normal text-font-md">
                      {formatAccountNumber(props?.payload?.old_bank_account)}
                    </span>
                    <p className="text-text-secondary mb-margin-sm font-normal text-font-xs">
                      Account number
                    </p>
                  </div>
                  <div className="items-center justify-between h-10 ">
                    <div className="bankImg bg-text-primary rounded-border-radius-md flex items-center justify-around flex-shrink-0 ">
                      <CommonBankLogo
                        ifsc={props?.payload?.old_ifsc_code || props?.ifsc_code}
                        variant="big"
                        type="pill"
                      />
                    </div>
                  </div>
                </div>

                <span className="text-text-primary font-normal mt-margin-sm text-font-md">
                  {props?.payload?.old_ifsc_code}
                </span>
                <p className="text-text-secondary font-normal mt-margin-xs text-font-xs">
                  IFSC code
                </p>

                {props?.payload?.old_virtual_account_type && (
                  <>
                    <p className="text-text-primary font-normal mt-margin-sm text-font-md ">
                      {props?.payload?.old_virtual_account_type === "automated"
                        ? "Auto detected"
                        : props?.payload?.old_virtual_account_type === "manual"
                          ? "Manually created"
                          : "N/A"}
                    </p>
                    <span className="text-text-secondary font-normal mt-margin-xs text-font-xs">
                      Virtual account
                    </span>
                  </>
                )}
              </div>
              <div className=" border-b border-primary-bg my-margin-sm w-full"></div>
              <div>
                <h5 className="text-text-primary font-semibold mb-margin-sm text-font-md capitalize">
                  Contact Details
                </h5>
                <span className=" text-text-primary font-normal mt-margin-sm text-font-md">
                  {props?.payload?.name || "Not available"}
                </span>
                <p className="text-text-secondary font-normal mb-margin-sm mt-margin-xs text-font-xs">
                  {props?.payload?.name?.trim() ===
                  props?.payload?.legal_name?.trim()
                    ? "Account name - Using legal name"
                    : "Account name"}
                </p>
                <span className="text-text-primary font-normal mt-margin-sm text-font-md">
                  +91 {props?.payload?.contact_no}
                </span>
                <p className="text-text-secondary font-normal my-margin-sm mt-margin-xs text-font-xs">
                  Contact number
                </p>

                <p className=" text-text-primary font-normal mt-margin-sm overflow-ellipsis w-width-almost-fulltext-font-md overflow-hidden whitespace-nowrap ">
                  {linkIdentifier(props?.payload?.email_id) || "Not available"}
                </p>

                <p className="text-text-secondary font-normal mt-margin-xs text-font-xs">
                  Email ID
                </p>
              </div>
            </div>
          </div>
        </div>
      </CommonLayout>
    </div>
  );
};

export default FieldForceAccountEditConfirm;
